import Http from './base-http'

class CalendarEvent extends Http {
  addCalendarEvent(variables) {
    return this.create(variables);
  }
  deleteCalendarEvent(id) {
    return this.destroy(id);
  }
}

const calendarEventObj = new CalendarEvent({
  modelUrlPrefix : 'CalendarEvent'
})

export default calendarEventObj